// Fuzzy filename <-> label matching, usado por las cargas masivas de fotos
// (Servicios, Galeria de resultados) para emparejar el nombre del archivo
// con el registro correspondiente sin exigir coincidencia exacta.

export function normalizeForMatch(str) {
  if (!str) return "";
  return str
    .normalize("NFD").replace(/[\u0300-\u036f]/g, "")
    .toLowerCase()
    .replace(/[_\-()]/g, " ")
    .replace(/[^a-z0-9 ]/g, " ")
    .replace(/\s+/g, " ")
    .trim();
}

export function stripExtension(filename) {
  const idx = filename.lastIndexOf(".");
  return idx > 0 ? filename.substring(0, idx) : filename;
}

function bigrams(str) {
  const grams = [];
  for (let i = 0; i < str.length - 1; i++) grams.push(str.substring(i, i + 2));
  return grams;
}

export function bigramSimilarity(a, b) {
  const na = normalizeForMatch(a);
  const nb = normalizeForMatch(b);
  if (!na || !nb) return 0;
  if (na === nb) return 1;
  const ga = bigrams(na);
  const gb = bigrams(nb);
  if (ga.length === 0 || gb.length === 0) return 0;
  const counts = new Map();
  ga.forEach((g) => counts.set(g, (counts.get(g) || 0) + 1));
  let intersection = 0;
  gb.forEach((g) => {
    const c = counts.get(g) || 0;
    if (c > 0) {
      intersection += 1;
      counts.set(g, c - 1);
    }
  });
  return (2 * intersection) / (ga.length + gb.length);
}

// Busca el mejor candidato para un nombre de archivo dado. `getLabel` extrae
// el texto comparable de cada candidato (ej. el nombre del servicio).
export function findBestMatch(filename, candidates, getLabel = (c) => c.name, threshold = 0.4) {
  const nameOnly = stripExtension(filename);
  let best = null;
  let bestScore = 0;
  candidates.forEach((c) => {
    const score = bigramSimilarity(nameOnly, getLabel(c));
    if (score > bestScore) {
      bestScore = score;
      best = c;
    }
  });
  if (!best || bestScore < threshold) return { match: null, score: bestScore };
  return { match: best, score: bestScore };
}
